import React from 'react';
import styled from 'styled-components';
import Top_Menu from '../main/Top_Menu';
import Bottom_Menu from '../main/Bottom_Menu';
import lang from '../language/Eng_eng.json';

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding-top: 100px;
  background-color: #F3EFE6;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #5C4033;
`;

const Title = styled.h1`
  font-family: 'EB Garamond', serif;
  font-size: 3.5rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  margin-bottom: 2rem;
`;

const ReservationButton = styled.a`
  padding: 15px 40px;
  background-color: #5C4033;
  color: #F3EFE6;
  font-family: 'EB Garamond', serif;
  font-size: 1.1rem;
  letter-spacing: 0.18rem;
  text-transform: uppercase;
  font-weight: 500;
  transition: opacity 0.3s ease;
  cursor: pointer;
  border: none;

  &:hover {
    opacity: 0.8;
  }
`;

const Reservation: React.FC = () => {
  return (
    <Container>
      <Top_Menu />
      <Content>
        <Title>RESERVATION</Title>
        <ReservationButton 
          href="https://www.opentable.com.au/booking/restref/availability?lang=en-AU&correlationId=2137dfd1-2106-4942-91d0-1229cda41100&restRef=263042&otSource=Restaurant%20website"
          target="_blank"
          rel="noopener noreferrer"
        >
          {lang.common.bookNow}
        </ReservationButton>
      </Content>
      <Bottom_Menu />
    </Container>
  );
};

export default Reservation;
